export default __webpack_public_path__ + "static/media/dan-boudet-resume-081626.38fa0385.pdf";